import { defineMessages } from 'react-intl';

export default defineMessages({
	heading: {
		id: 'familyPlanLanding.hero.heading',
		defaultMessage: 'A Calm family is a happy family',
		description: 'Explanation of what family plan is',
	},
	headingAccept: {
		id: 'familyPlanLanding.hero.headingAccept',
		defaultMessage: '{name} invited you to their Premium Family',
		description: 'Explanation of what family plan is',
	},
	headingAcceptNoName: {
		id: 'familyPlanLanding.hero.headingAcceptNoName',
		defaultMessage: 'You have been invited to Premium Family',
		description: 'Explanation of what family plan is',
	},
	subheading: {
		id: 'familyPlanLanding.hero.subheading',
		defaultMessage: 'Six Premium accounts for {price}/year.',
		description: 'Pricing for family plan',
	},
	subheadingAccept: {
		id: 'familyPlanLanding.hero.subheadingAccept',
		defaultMessage: 'Accept invite for unlimited access to meditations, Sleep Stories, and more',
		description: 'Pricing for family plan',
	},
	cta: {
		id: 'familyPlanLanding.hero.cta',
		defaultMessage: 'Get Premium Family',
		description: 'Button which leads user to payment form',
	},
	ctaAccept: {
		id: 'familyPlanLanding.hero.ctaAccept',
		defaultMessage: 'Accept Invite',
		description: 'Button which leads user to payment form',
	},
});
